export enum BitacoraTiposEnum {
    REQUEST, BUG, FIX
}

const idsBitacoraTipos = new Map<BitacoraTiposEnum, string>();
idsBitacoraTipos.set(BitacoraTiposEnum.REQUEST, "REQUEST");
idsBitacoraTipos.set(BitacoraTiposEnum.BUG, "BUG");
idsBitacoraTipos.set(BitacoraTiposEnum.FIX, "FIX");

const nombresBitacoraTipos = new Map<BitacoraTiposEnum, string>();
nombresBitacoraTipos.set(BitacoraTiposEnum.REQUEST, "Request");
nombresBitacoraTipos.set(BitacoraTiposEnum.BUG, "Bug");
nombresBitacoraTipos.set(BitacoraTiposEnum.FIX, "Fix");

export const obtenerIdBitacoraTipo: (tipo: BitacoraTiposEnum) => string =
    bitacora => idsBitacoraTipos.get(bitacora) ?? "";
export const obtenerNombreBitacoraTipo: (tipo: BitacoraTiposEnum) => string =
    bitacora => nombresBitacoraTipos.get(bitacora) ?? "";

export const obtenerNombresBitacoraTipo: () => [BitacoraTiposEnum, string][] =
    () => Array.from(nombresBitacoraTipos.entries());
